import { ReactNode } from 'react';
import { TextVariant } from './types';

export const MAIN_EVENT_CONSTANTS: Record<string, TextVariant> = {
  ticketDetail: { common: '토너먼트 참가 안내에서 상세 일정을 확인해주세요.' },
  btnText: { common: '오프라인 이벤트 참가 안내' },
};

export const getWelcomeText = (totalCount: number, usedCount: number): ReactNode => (
  <>
    참가권 사용하기는 <span>오프라인 이벤트 당일부터</span> 보여집니다.
    <br /> 보유 참가권 : {totalCount} 장 / 사용 참가권 : {usedCount} 장
  </>
);
